module.exports = __webpack_public_path__ + "assets/img/c3.504bc73c.png";